export default __webpack_public_path__ + "static/media/left-arrow.ca9470d7.svg";